/**
 * Shipment tracking URL helper.
 *
 * Mirror of the mobile `-maabar-app/src/lib/tracking.js` (keep the two in sync).
 *
 * Scope note: `getTrackingUrl` is ALSO inlined, in two slightly different
 * versions, in `src/pages/DashboardBuyer.jsx` and `src/pages/DashboardSupplier.jsx`
 * for the direct-order flow. Those duplications are deliberately left alone here —
 * consolidating them is a separate concern. New callers import from this module.
 */

// `manualUrl` covers a local carrier that none of the known trackers handle —
// the admin pastes the carrier's own tracking page and it wins outright. Anything
// that is not an http(s) URL is ignored rather than trusted, so a half-typed value
// falls back to the carrier map instead of producing a broken link.
export function getTrackingUrl(company, num, manualUrl) {
  const manual = String(manualUrl || '').trim();
  if (/^https?:\/\//i.test(manual)) return manual;

  const safeNum = encodeURIComponent(String(num || ''));
  const urls = {
    DHL: `https://www.dhl.com/track?tracking-id=${safeNum}`,
    FedEx: `https://www.fedex.com/tracking?tracknumbers=${safeNum}`,
    Aramex: `https://www.aramex.com/track/${safeNum}`,
    UPS: `https://www.ups.com/track?tracknum=${safeNum}`,
    SMSA: `https://www.smsaexpress.com/track?awbno=${safeNum}`,
  };
  // 17track aggregates most remaining carriers, including the Saudi last-mile ones.
  return urls[company] || `https://t.17track.net/en#nums=${safeNum}`;
}

export const CARRIERS = ['DHL', 'FedEx', 'Aramex', 'UPS', 'SMSA', 'Other'];
